var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCatalog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6191 1.12596H4.50162C4.20348 1.12596 3.91755 1.24439 3.70672 1.45522C3.4959 1.66604 3.37747 1.95198 3.37747 2.25013V4.49846H2.2533V5.62262H3.37747V8.43303H2.2533V9.5572H3.37747V12.3677H2.2533V13.4918H3.37747V15.7401C3.37747 16.0382 3.4959 16.3242 3.70672 16.5351C3.91755 16.7458 4.20348 16.8643 4.50162 16.8643H14.6191C14.9172 16.8643 15.2032 16.7458 15.4141 16.5351C15.6248 16.3242 15.7433 16.0382 15.7433 15.7401V2.25013C15.7433 1.95198 15.6248 1.66604 15.4141 1.45522C15.2032 1.24439 14.9172 1.12596 14.6191 1.12596ZM14.6191 15.7401H4.50162V13.4918H5.62579V12.3677H4.50162V9.5572H5.62579V8.43303H4.50162V5.62262H5.62579V4.49846H4.50162V2.25013H14.6191V15.7401Z",
    className: "svgFill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.87415 4.49843H12.3708V5.6226H7.87415V4.49843ZM7.87415 8.43301H12.3708V9.55717H7.87415V8.43301ZM7.87415 12.3675H12.3708V13.4918H7.87415V12.3675Z",
    className: "svgFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalog);
export default __webpack_public_path__ + "static/media/catalog.3b588b50.svg";
export { ForwardRef as ReactComponent };